import { WorldPosition } from 'types'

export type KVSurfaceAreaJSON = {
  surfaceAreaId: string
  surfaceAreaLabel: string
  surfaceAreaVisible: boolean
  surfaceAreaPoints: WorldPosition[]
}

export class KVSurfaceArea {
  surfaceAreaId: string
  surfaceAreaLabel: string
  surfaceAreaVisible: boolean
  surfaceAreaPoints: WorldPosition[]

  constructor(id: string) {
    this.surfaceAreaId = id
    this.surfaceAreaLabel = 'Surface Area'
    this.surfaceAreaVisible = true
    this.surfaceAreaPoints = []
  }

  get id(): string {
    return this.surfaceAreaId
  }

  static fromJSON(json: KVSurfaceAreaJSON): KVSurfaceArea {
    const surfaceArea = new KVSurfaceArea(json.surfaceAreaId)
    if (json.surfaceAreaLabel)
      surfaceArea.surfaceAreaLabel = json.surfaceAreaLabel
    if (json.surfaceAreaVisible !== undefined)
      surfaceArea.surfaceAreaVisible = json.surfaceAreaVisible
    if (json.surfaceAreaPoints)
      surfaceArea.surfaceAreaPoints = json.surfaceAreaPoints
    return surfaceArea
  }

  static toJSON(surfaceArea: KVSurfaceArea): KVSurfaceAreaJSON {
    return {
      surfaceAreaId: surfaceArea.surfaceAreaId,
      surfaceAreaLabel: surfaceArea.surfaceAreaLabel,
      surfaceAreaVisible: surfaceArea.surfaceAreaVisible,
      surfaceAreaPoints: surfaceArea.surfaceAreaPoints,
    }
  }
}
